import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import JobCard from "../components/JobCard";
import jobsData from "../data/jobs";
import "./Home.css";

const JobList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const jobsPerPage = 10;

  // 🔍 Filter jobs based on searchTerm and filterType
  const filteredJobs = jobsData.filter((job) => {
    const matchesSearch = job.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType ? job.type.toLowerCase() === filterType.toLowerCase() : true;
    return matchesSearch && matchesType;
  });

  // 📑 Pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  // Split jobs into two columns dynamically
  const half = Math.ceil(currentJobs.length / 2);
  const leftColumnJobs = currentJobs.slice(0, half);
  const rightColumnJobs = currentJobs.slice(half);

  return (
    <div className="container mt-5">
      {/* ✅ Search Bar */}
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={(val) => {
          setSearchTerm(val);
          setCurrentPage(1); // Reset page on search
        }}
        filterType={filterType}
        setFilterType={(val) => {
          setFilterType(val);
          setCurrentPage(1); // Reset page on filter
        }}
        setCurrentPage={setCurrentPage}
      />

      {/* ✅ Job Listings */}
      {currentJobs.length > 0 ? (
        <div className="job-columns-wrapper mt-4 d-flex gap-4">
          <div className="job-column flex-fill">
            {leftColumnJobs.map((job) => (
              <JobCard key={job.id} job={job} />
            ))}
          </div>
          <div className="job-column flex-fill">
            {rightColumnJobs.map((job) => (
              <JobCard key={job.id} job={job} />
            ))}
          </div>
        </div>
      ) : (
        <p className="mt-4 text-center">⚠️ No jobs found.</p>
      )}

      {/* ✅ Pagination */}
      {totalPages > 1 && (
        <nav className="mt-4">
          <ul className="pagination justify-content-center">
            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index}
                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default JobList;
